import { request } from './api';

/**
 * Action constants
 */

/**
 * Action creators
 */

export function logEvent(event) {
  return (dispatch) =>
    dispatch(request('get', `/auth/user/log/?event=${event}`)).catch(
      () => null
    );
}

/**
 * Helper Functions
 */
// function parseErr(err) {
//   if (err.non_field_errors) {
//     return err.non_field_errors[0];
//   }

//   return err.msg || err.detail || 'Server Error';
// }
